// OkLab / OkLCh (Ottosson), §6.5: linear P3 → linear sRGB (unclamped) → OkLab.
import { apply, inv, P3_TO_SRGB, SRGB_TO_P3, type Mat3, type Vec3 } from './matrix';

export const OK_M1: Mat3 = [
  [0.4122214708, 0.5363325363, 0.0514459929],
  [0.2119034982, 0.6806995451, 0.1073969566],
  [0.0883024619, 0.2817188376, 0.6299787005],
];
export const OK_M2: Mat3 = [
  [0.2104542553, 0.793617785, -0.0040720468],
  [1.9779984951, -2.428592205, 0.4505937099],
  [0.0259040371, 0.7827717662, -0.808675766],
];
export const OK_M1_INV = inv(OK_M1);
export const OK_M2_INV = inv(OK_M2);

export function linearSrgbToOklab(rgb: Vec3): Vec3 {
  const lms = apply(OK_M1, rgb);
  return apply(OK_M2, [Math.cbrt(lms[0]), Math.cbrt(lms[1]), Math.cbrt(lms[2])]);
}
export function oklabToLinearSrgb(lab: Vec3): Vec3 {
  const l = apply(OK_M2_INV, lab);
  return apply(OK_M1_INV, [l[0] ** 3, l[1] ** 3, l[2] ** 3]);
}

export const p3ToOklab = (rgb: Vec3): Vec3 => linearSrgbToOklab(apply(P3_TO_SRGB, rgb));
export const oklabToP3 = (lab: Vec3): Vec3 => apply(SRGB_TO_P3, oklabToLinearSrgb(lab));

/** OkLab → OkLCh with hue in degrees 0..360. */
export function toLch(lab: Vec3): Vec3 {
  const C = Math.hypot(lab[1], lab[2]);
  let h = (Math.atan2(lab[2], lab[1]) * 180) / Math.PI;
  if (h < 0) h += 360;
  return [lab[0], C, h];
}
export function fromLch(lch: Vec3): Vec3 {
  const r = (lch[2] * Math.PI) / 180;
  return [lch[0], lch[1] * Math.cos(r), lch[1] * Math.sin(r)];
}
